import { Cup, CupSize, CupVariant, } from 'root/src/client/web/giveaway/components/Cup';
import { memo } from 'react';
import { CreateGiveawayForm } from 'root/src/client/v2/giveaways/features/CreateGiveawayModal/components/CreateGiveawayForm';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { useCreateGiveawayModal } from 'root/src/client/v2/giveaways/features/CreateGiveawayModal/hooks/useCreateGiveawayModal';
import { ModalLoader } from 'root/src/client/v2/common/components/modal/ModalLoader';
export const CreateGiveawayModal = memo((props) => {
    const { isLoading, giveaway, scheduler, giveawayConfig, onCancelScheduler, onSubmit, } = useCreateGiveawayModal(props);
    if (isLoading) {
        return <ModalLoader />;
    }
    return (<ModalLayout>
			<div className="flex flex-col gap-4 px-4 sm:min-w-[500px]">
				<div className="flex items-center justify-center">
					<Cup variant={CupVariant.Gold} size={CupSize.SMALL}/>
					<h1 className="mx-2 font-mono capitalize font-bold text-center text-2xl">
						Effortless giveaways
					</h1>
				</div>
				<h2 className="text-center">
					Set schedule, then focus on your content.
				</h2>
				<CreateGiveawayForm onSubmit={onSubmit} onCancel={onCancelScheduler} giveawayConfig={giveawayConfig} giveaway={giveaway} scheduler={scheduler}/>
			</div>
		</ModalLayout>);
});
